import { ReactComponent as BikingSvg } from '../../../../assets/svg/workout/biking.svg';
import { ReactComponent as RunningSvg } from '../../../../assets/svg/workout/run.svg';
import { ReactComponent as WalkingSvg } from '../../../../assets/svg/workout/walk.svg';
import { ReactComponent as TreadmillSvg } from '../../../../assets/svg/workout/treadmill_running.svg';
import { ReactComponent as EllipticalSvg } from '../../../../assets/svg/workout/elliptical_training.svg';
import { ReactComponent as RowingSvg } from '../../../../assets/svg/workout/rowing_machine.svg';
import { ReactComponent as HikingSvg } from '../../../../assets/svg/workout/hiking.svg';
import { ReactComponent as SwimmingSvg } from '../../../../assets/svg/workout/swimming.svg';
import { ReactComponent as PilatesSvg } from '../../../../assets/svg/workout/stretch_01.svg';
import { ReactComponent as BalletSvg } from '../../../../assets/svg/workout/stretch_03.svg';
import { ReactComponent as YogaSvg } from '../../../../assets/svg/workout/meditation.svg';
import { ReactComponent as StretchingSvg } from '../../../../assets/svg/workout/stretch_02.svg';
import { ReactComponent as WaterPoloSvg } from '../../../../assets/svg/workout/playing_water_polo.svg';
import { ReactComponent as BasketballSvg } from '../../../../assets/svg/workout/playing_basketball.svg';
import { ReactComponent as SoccerSvg } from '../../../../assets/svg/workout/playing_soccer.svg';
import { ReactComponent as BaseballSvg } from '../../../../assets/svg/workout/playing_baseball.svg';
import { ReactComponent as TennisSvg } from '../../../../assets/svg/workout/playing_tennis.svg';
import { ReactComponent as VolleyballSvg } from '../../../../assets/svg/workout/playing_volleyball.svg';
import { ReactComponent as BadmintonSvg } from '../../../../assets/svg/workout/playing_badminton.svg';
import { ReactComponent as GolfSvg } from '../../../../assets/svg/workout/playing_golf.svg';
import { ReactComponent as RugbySvg } from '../../../../assets/svg/workout/playing_rugby.svg';
import { ReactComponent as HockeySvg } from '../../../../assets/svg/workout/playing_hockey.svg';
import { ReactComponent as IceHockeySvg } from '../../../../assets/svg/workout/playing_ice_hockey.svg';
import { ReactComponent as SurfingSvg } from '../../../../assets/svg/workout/surfing.svg';
import { ReactComponent as FencingSvg } from '../../../../assets/svg/workout/fencing.svg';
import { ReactComponent as BoxingSvg } from '../../../../assets/svg/workout/boxing.svg';
import { ReactComponent as ClimbingSvg } from '../../../../assets/svg/workout/rock_climbing.svg';
import { ReactComponent as SkiingSvg } from '../../../../assets/svg/workout/alpine_skiing.svg';
import { ReactComponent as SnowboardingSvg } from '../../../../assets/svg/workout/speed_skating-1.svg';
import { ReactComponent as SkatingSvg } from '../../../../assets/svg/workout/speed_skating.svg';
import { ReactComponent as CyclingSvg } from '../../../../assets/svg/workout/biking-1.svg';

const list = (type) => {
  if (type === 'cardio') {
    return [
      {
        name: 'Walking',
        icon: <WalkingSvg className='w-12 h-12' />,
      },
      {
        name: 'Running',
        icon: <RunningSvg className='w-12 h-12' />,
      },
      {
        name: 'Biking',
        icon: <BikingSvg className='w-12 h-12' />,
      },
      {
        name: 'Treadmill',
        icon: <TreadmillSvg className='w-12 h-12' />,
      },
      {
        name: 'Elliptical',
        icon: <EllipticalSvg className='w-12 h-12' />,
      },
      {
        name: 'Rowing',
        icon: <RowingSvg className='w-12 h-12' />,
      },
      {
        name: 'Hiking',
        icon: <HikingSvg className='w-12 h-12' />,
      },
      {
        name: 'Swimming',
        icon: <SwimmingSvg className='w-12 h-12' />,
      },
      {
        name: 'Custom',
        icon: <div className='text-white text-center text-4xl'>+</div>,
      },
    ];
  }
  if (type === 'home') {
    return [
      { name: 'Full Body' },
      { name: 'Upper Body' },
      { name: 'Lower Body' },
      { name: 'Chest' },
      { name: 'Back' },
      { name: 'Shoulders' },
      { name: 'Arms' },
      { name: 'Biceps' },
      { name: 'Triceps' },
      { name: 'Abs/Core' },
      { name: 'Legs' },
    ];
  }
  if (type === 'gym') {
    return [
      { name: 'Full Body' },
      { name: 'Upper Body' },
      { name: 'Lower Body' },
      { name: 'Chest' },
      { name: 'Back' },
      { name: 'Shoulders' },
      { name: 'Arms' },
      { name: 'Biceps' },
      { name: 'Triceps' },
      { name: 'Abs/Core' },
      { name: 'Legs' },
    ];
  }
  if (type === 'hiit') {
    return [
      { name: 'Full Body' },
      { name: 'Upper Body' },
      { name: 'Lower Body' },
      { name: 'Chest' },
      { name: 'Back' },
      { name: 'Shoulders' },
      { name: 'Arms' },
      { name: 'Biceps' },
      { name: 'Triceps' },
      { name: 'Abs/Core' },
      { name: 'Legs' },
    ];
  }
  if (type === 'core') {
    return [
      { name: 'Pilates', icon: <PilatesSvg className='w-12 h-12' /> },
      { name: 'Ballet', icon: <BalletSvg className='w-12 h-12' /> },
      { name: 'Yoga', icon: <YogaSvg className='w-12 h-12' /> },
      {
        name: 'Custom',
        icon: <div className='text-white text-center text-4xl'>+</div>,
      },
    ];
  }
  if (type === 'stretching') {
    return [
      { name: 'Stretching', icon: <StretchingSvg className='w-12 h-12' /> },
      {
        name: 'Custom',
        icon: <div className='text-white text-center text-4xl'>+</div>,
      },
    ];
  }
  if (type === 'sports') {
    return [
      { name: 'Water Polo', icon: <WaterPoloSvg className='w-12 h-12' /> },
      { name: 'Basketball', icon: <BasketballSvg className='w-12 h-12' /> },
      { name: 'Soccer', icon: <SoccerSvg className='w-12 h-12' /> },
      { name: 'Baseball', icon: <BaseballSvg className='w-12 h-12' /> },
      { name: 'Tennis', icon: <TennisSvg className='w-12 h-12' /> },
      { name: 'Badminton', icon: <BadmintonSvg className='w-12 h-12' /> },
      { name: 'Volleyball', icon: <VolleyballSvg className='w-12 h-12' /> },
      { name: 'Rugby', icon: <RugbySvg className='w-12 h-12' /> },
      { name: 'Hockey', icon: <HockeySvg className='w-12 h-12' /> },
      { name: 'Golf', icon: <GolfSvg className='w-12 h-12' /> },
      { name: 'Surfing', icon: <SurfingSvg className='w-12 h-12' /> },
      { name: 'Fencing', icon: <FencingSvg className='w-12 h-12' /> },
      { name: 'Boxing', icon: <BoxingSvg className='w-12 h-12' /> },
      { name: 'Climbing', icon: <ClimbingSvg className='w-12 h-12' /> },
      {
        name: 'Swimming',
        icon: <SwimmingSvg className='w-12 h-12' />,
      },
      {
        name: 'Cycling',
        icon: <CyclingSvg className='w-12 h-12' />,
      },
      { name: 'Ice Hockey', icon: <IceHockeySvg className='w-12 h-12' /> },
      { name: 'Skating', icon: <SkatingSvg className='w-12 h-12' /> },
      { name: 'Snowboarding', icon: <SnowboardingSvg className='w-12 h-12' /> },
      { name: 'Skiing', icon: <SkiingSvg className='w-12 h-12' /> },
      {
        name: 'Custom',
        icon: <div className='text-white text-center text-4xl'>+</div>,
      },
    ];
  }

  return [];
};

const DetailTypes = ({
  type,
  selectedDetailType,
  handleSelectDetailType,
  customDetailType,
  handleRemoveCustomDetailType,
  openAddExerciseDialog,
  isMultiDetailTypeWorkout,
}) => {
  return (
    <div className='space-y-2 mb-4'>
      <div className='w-full overflow-hidden'>
        <h3 className='text-white/50 text-xs'>Select workout type (Max 5)</h3>
        <div className='flex items-center gap-4 py-2 overflow-x-scroll scrollbar-hidden'>
          {list(type.type).map((item) => (
            <button
              key={item.name}
              className={`flex-shrink-0 size-24 flex items-center justify-center rounded-xl cursor-pointer ${
                selectedDetailType.includes(item.name)
                  ? 'bg-secondary border-2 border-accent'
                  : 'bg-tertiary'
              }`}
              onClick={() => handleSelectDetailType(item.name)}
            >
              {item.icon ? (
                <div className='flex flex-col items-center justify-center gap-1'>
                  <div>{item.icon}</div>
                  <p className='text-white text-center text-xs'>{item.name}</p>
                </div>
              ) : (
                <div className='text-white text-center text-lg font-bold'>
                  {item.name}
                </div>
              )}
            </button>
          ))}
        </div>
      </div>

      {customDetailType.length > 0 && (
        <div>
          <h3 className='text-white/50 text-xs mb-2'>Custom workout type</h3>
          <div className='flex items-center gap-2 overflow-x-scroll scrollbar-hidden'>
            {customDetailType.map((type, i) => (
              <div
                key={i}
                className='flex-shrink-0 bg-secondary rounded-lg px-4 py-2 flex items-center gap-3 border border-accent'
              >
                <span className='text-white text-sm capitalize'>{type}</span>
                <button
                  onClick={() => handleRemoveCustomDetailType(i)}
                  className='text-white text-sm'
                >
                  x
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      {isMultiDetailTypeWorkout &&
        (selectedDetailType.length > 0 || customDetailType.length > 0) && (
          <div>
            <button
              onClick={openAddExerciseDialog}
              className='flex items-center justify-center text-white bg-secondary rounded-xl w-full h-12 gap-2'
            >
              <span>Add Exercise</span>
              <span className='text-2xl'>+</span>
            </button>
          </div>
        )}
    </div>
  );
};

export default DetailTypes;
